<script lang="ts">
	import { twJoin } from "tailwind-merge";
	import type { PageContainer } from "#gen/bundles/v1/bundle_pb.js";
	import type { LayoutProps } from "#lib/components/flow/viewer/layout/types.js";
	import PageBackgroundLayer, { hostBackgroundStyle } from "#lib/components/page/PageBackgroundLayer.svelte";
	import { APP_ANCHOR_NAME } from "#lib/dag.js";

	const { modal = false, backgroundPaint = "inline", style, share, apps, accessory }: LayoutProps<PageContainer> = $props();
</script>

<div class="h-full w-full justify-center" {style}>
	<div style={hostBackgroundStyle(backgroundPaint)} class={twJoin("flex h-full w-full flex-col gap-2 bg-white", backgroundPaint === "layer" && "relative isolate")} class:pt-4={!modal}>
		{#if backgroundPaint === "layer"}<PageBackgroundLayer />{/if}
		{@render share?.()}
		<div class={twJoin("flex h-full flex-col gap-3", !modal && "px-4 pb-5")}>
			<div class="relative">
				{@render apps?.()}
			</div>
			{#if accessory?.[APP_ANCHOR_NAME]}
				<div class="relative">
					{@render accessory?.[APP_ANCHOR_NAME]?.()}
				</div>
			{/if}
		</div>
	</div>
</div>
